import { useGridApiContext } from '@mui/x-data-grid';
import React from 'react'
import { Projection } from './types';
import { Box, Button } from '@material-ui/core';

interface OwnProps {
  readonly onSetProjections: (projections: Projection[]) => void;
  readonly disabled: boolean;
}

type Props = OwnProps;

const Footer = (props: Props) => {
  const apiRef = useGridApiContext();
  const { disabled, onSetProjections } = props;

  const getData = () => {
    const data = apiRef.current.state.rows.dataRowIds.map(x => apiRef.current.getRowParams(x).row)
    return data;
  }
  getData();
  return (
    <Box paddingRight="12px">
      <Button disabled={disabled} onClick={() => onSetProjections(getData())} style={{ textTransform: 'none', color: disabled ? 'grey' : 'white', background: '#015ACE', borderRadius: '3px',  }}>Run Contest Simulation</Button>
    </Box>
  )
}

export default Footer